.dialog { container-type: inline-size; padding: var(--sp-5); color: var(--ink); }
.dialog h2, .dialog h3 { margin: 0; }
.dialog header > p, .seriesHead p { margin: var(--sp-1) 0 0; color: var(--muted); }
.fields { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: var(--sp-4); margin-top: var(--sp-5); }
.range { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1.4fr); gap: var(--sp-2); }
.series { margin-top: var(--sp-5); padding-top: var(--sp-4); border-top: 1px solid var(--hair, var(--border)); }
.seriesHead, .seriesRow, .footer { display: flex; align-items: center; gap: var(--sp-3); }
.seriesHead { justify-content: space-between; }
.seriesRow { display: grid; grid-template-columns: minmax(130px, .7fr) minmax(180px, 1fr) auto; margin-top: var(--sp-3); }
.problem { color: var(--crit); margin: var(--sp-4) 0 0; }
.footer { margin-top: var(--sp-5); padding-top: var(--sp-4); border-top: 1px solid var(--hair, var(--border)); }
.grow { flex: 1; }

@container (max-width: 680px) {
  .fields { grid-template-columns: 1fr; }
  .seriesRow { grid-template-columns: 1fr; }
  .footer { flex-wrap: wrap; }
  .footer .grow { flex-basis: 100%; }
}
